module.exports = __webpack_public_path__ + "static/food-blog-web-plp-5aecb0eb94511d9d318e5ae6acd5550e.png";